import service_img_1 from "../assets/Images/service-img-1.jpg"
import service_img_2 from "../assets/Images/service-img-2.jpg"
import service_img_3 from "../assets/Images/service-img-3.jpg"
import service_img_4 from "../assets/Images/service-img-4.jpg"
import service_img_5 from "../assets/Images/service-img-5.jpg"
import service_img_6 from "../assets/Images/service-img-6.jpg"
import service_img_7 from "../assets/Images/service-img-7.jpg"
import service_img_8 from "../assets/Images/service-img-8.jpg"
import service_img_9 from "../assets/Images/service-img-9.jpg"
import clinic_1 from "../assets/Images/clinic-1.jpg"
import clinic_2 from "../assets/Images/clinic-2.jpg"
import clinic_3 from "../assets/Images/clinic-3.jpg"
import clinic_4 from "../assets/Images/clinic-4.jpg"
import clinic_5 from "../assets/Images/clinic-5.jpg"
import clinic_6 from "../assets/Images/clinic-6.jpg"
import clinic_7 from "../assets/Images/clinic-7.jpg"
import clinic_8 from "../assets/Images/clinic-8.jpg"
import allPaths from "../Config/paths"

const doctorsMenuItems = [
    {
        menuName: 'Calendar',
        menuALName: 'Calendar',
        menuGLName: 'Calendar',
        menuRoute: allPaths?.DOCTOR_CALANDER,
    },
    {
        menuName: 'Profile',
        menuALName: 'Profile',
        menuGLName: 'Profile',
        menuRoute: allPaths?.DOCTOR_PROFILE,
    },
]
const menuItems = [
    {
        menuName: 'Home',
        menuALName: 'بيت',
        menuGLName: 'Heim',
        menuRoute: allPaths?.HOME,
    },
    {
        menuName: 'Services',
        menuALName: 'الخدمات',
        menuGLName: 'Dienstleistungen',
        menuRoute: allPaths?.SERVICE,
    },
    {
        menuName: 'Our Clinic',
        menuALName: 'عيادتنا',
        menuGLName: 'Unsere Klinik',
        menuRoute: allPaths?.CLINIC,
    },
    {
        menuName: 'Sterilization',
        menuALName: 'التعقيم',
        menuGLName: 'Sterilisation',
        menuRoute: allPaths?.STERILIZATION,
    },
    {
        menuName: 'Our Team',
        menuALName: 'فريقنا',
        menuGLName: 'Unser Team',
        menuRoute: allPaths?.OURTEAM,
    },
    {
        menuName: 'Why Egypt',
        menuALName: 'لماذا مصر',
        menuGLName: 'Warum Ägypten',
        menuRoute: allPaths?.EGYPT,
    },
    {
        menuName: 'Contact Us',
        menuALName: 'اتصل بنا',
        menuGLName: 'Kontaktieren Sie uns',
        menuRoute: allPaths?.CONTACT,
    },
    {
        menuName: 'Blog',
        menuALName: 'مدونة',
        menuGLName: 'Blog',
        menuRoute: allPaths?.BLOG,
    },
    {
        menuName: 'Service Form',
        menuGLName: 'Serviceformular',
        menuALName: 'نموذج الخدمة',
        menuRoute: allPaths?.SERVICEFORM,
        forclanic: true
    },
    {
        menuName: 'Doctor Form',
        menuGLName: 'Arztformular',
        menuALName: 'استمارة دكتور',
        menuRoute: allPaths?.DOCTORFORM,
        forclanic: true
    },
    {
        menuName: 'Room',
        menuGLName: 'Room',
        menuALName: 'Room',
        menuRoute: allPaths?.DOCTOR_ROOM,
        forclanic: true
    },
    {
        menuName: 'Profile',
        menuGLName: 'Profile',
        menuALName: 'Profile',
        menuRoute: allPaths?.CLANIC_PROFILE,
        forclanic: true
    },
];

const serviceData = [
    {
        imageUrl: service_img_1,
        path: allPaths?.DENTALSERVICE,
        heading: 'DENTAL DIAGNOSES & GP',
        text: 'The diagnosis is the most important part in modern dentistry in order to ensure the best and a suitable treatment plan.',
    },
    {
        imageUrl: service_img_2,
        path: allPaths?.AESTHETICSDENTISTRY,
        heading: 'AESTHETICS DENTISTRY',
        text: 'Laser whitening, composite restorations, porcelain crowns, hi-Ceram, inlays, on lays, and porcelain laminate veneers.',
    },
    {
        imageUrl: service_img_3,
        path: allPaths?.ENDODONTICDENTISTRY,
        heading: 'ENDODONTIC DENTISTRY',
        text: 'The root canal therapy is now possible in a painless single visit with latest technologies available at our clinic',
    },
    {
        imageUrl: service_img_4,
        path: allPaths?.ORALSURGERY,
        heading: 'ORAL SURGERY',
        text: 'Our Surgeons are highly qualififed in simple extraction, surgical extraction, bone grafts and orthognathic surgery',
    },
    {
        imageUrl: service_img_5,
        path: allPaths?.ORTHODONTICDENTISTRY,
        heading: 'ORTHODONTIC DENTISTRY',
        text: 'Primadent offers Invisalign, Clear & metal braces and Lingual braces with our highly specialised orthodontists',
    },
    {
        imageUrl: service_img_6,
        path: allPaths?.PROSTHODONTICDENTISTRY,
        heading: 'PROSTHODONTIC DENTISTRY',
        text: 'Our dental center provides the full range of dental treatments services for bridges/crowns, complete or partial dentures and dental implants.',
    },
    {
        imageUrl: service_img_7,
        path: allPaths?.PERIODONTALDENTISTRY,
        heading: 'PERIODONTAL DENTISTRY',
        text: 'We provide various solutions for major periodontal diseases. Our periodontists will diagnose and treat you with the latest technologies available',
    },
    {
        imageUrl: service_img_8,
        path: allPaths?.DENTALIMPLANTS,
        heading: 'DENTAL IMPLANTS',
        text: "With today's advancements in dental implant and bone grafting techniques, materials and technologies, almost anyone with missing teeth can now have dental implant treatments done.",
    },
    {
        imageUrl: service_img_9,
        path: allPaths?.PEDODONTICDENTISTRY,
        heading: 'PEDODONTIC DENTISTRY',
        text: 'Children love to come to our clinic as we combine dental treatment with fun.',
    },
];

const clinicImgSrc = [
    clinic_1,
    clinic_2,
    clinic_3,
    clinic_4,
    clinic_5,
    clinic_6,
    clinic_7,
    clinic_8
]

const allDesigns = [
    {
        name: 'Design 1',
        val: 'clinic-design-1',
    },
    {
        name: 'Design 2',
        val: 'clinic-design-2',
    },
    {
        name: 'Design 3',
        val: 'clinic-design-3',
    },
    {
        name: 'Design 4',
        val: 'clinic-design-4',
    },
    {
        name: 'Design 5',
        val: 'clinic-design-5',
    }
]

export {
    allPaths,
    serviceData,
    clinicImgSrc,
    menuItems,
    doctorsMenuItems,
    allDesigns
}